import { BusinessEntityType } from '@grc/ui-shared/lib/components/models/enums/enums';
import { getBusinessEntities } from './get-business-entities';

export default async function GetBillToName(fetchData: any, billToId: string) {
  try {
    const billTo = await getBusinessEntities(fetchData, {
      status: true,
      locationIds: [billToId],
      entityType: BusinessEntityType.BillTo
    });
    return billTo?.data?.[0]?.name ?? '';
  } catch (error) {
    console.log(error, 'line no 8');
  }
}
